import { Button, Empty, message, Table } from 'antd';
import * as moment from 'moment';
import React from 'react';
import { Query } from 'react-apollo';
import * as CopyToClipboard from 'react-copy-to-clipboard';
import { Enrollment, LearnedLesson } from 'src/types/enrollment';
import { SpeechTypeText } from 'src/types/speech';

import { USERS_QUERY } from '../../query/returnVisit';
import { EnrollmentReport, Statistics } from '../enrollment/Enrollment';

export const ExpandedRowRender = (props: { record: Enrollment }) => {
  const { record } = props;

  if (!record.returnVisit) {
    // @ts-ignore
    return <Empty />;
  }

  const isVisited = !!(
    record.returnVisit.lastReturnVisitAt && moment().isSame(record.returnVisit.lastReturnVisitAt, 'isoWeek')
  );

  let newLearnedLessons: LearnedLesson[] = (record.returnVisit && record.returnVisit.newLearnedLessons) || [];

  if (isVisited) {
    newLearnedLessons = (record.returnVisit && record.returnVisit.lastVisitedLessons) || [];
  }
  const lessonIds = newLearnedLessons.map(newLearnedLesson => newLearnedLesson.id);

  return (
    <Query
      query={USERS_QUERY}
      variables={{
        lessonIds,
        ids: [record.user.id],
        enrollmentIds: [record.id],
        speechDateRange: {
          from: moment().subtract(10, 'days').startOf('day').toDate(),
          to: moment().endOf('day').toDate(),
        },
      }}
    >
      {({ loading, error, data }) => {
        if (loading) {
          return 'loading...';
        }
        if (error || !data) {
          return 'error';
        }

        const [user] = data.users;
        if (!user) {
          // @ts-ignore
          return <Empty />;
        }

        const [enrollment] = user.enrollments;
        if (!enrollment) {
          // @ts-ignore
          return <Empty />;
        }

        const { knowledgePoints } = enrollment.enrollmentReport as EnrollmentReport;

        return (
          <Table dataSource={knowledgePoints} pagination={false} rowKey={() => Math.random().toString()}>
            <Table.Column width={'5%'} title="知识点" dataIndex="name" key="speechKnowledgeName" />
            <Table.Column<Statistics>
              sorter={(a, b) => {
                if (a.highestAccuracy === 0) return 1; // Return 1 so that b goes first
                if (b.highestAccuracy === 0) return -1; // Return -1 so that a goes first
                return a.highestAccuracy - b.highestAccuracy;
              }}
              width={'5%'}
              title="最高正确率"
              dataIndex="highestAccuracy"
              key="speechHighestAccuracy"
              render={highestAccuracy => `${(highestAccuracy * 100).toFixed(0)}%`}
            />
            <Table.Column
              width={'5%'}
              title="所有正确率"
              dataIndex="allAccuracies"
              key="speechAllAccuracies"
              render={allAccuracies =>
                allAccuracies.map((item: number, index: number) => {
                  let content = `${(item * 100).toFixed(0)}%`;
                  if (index < allAccuracies.length - 1) {
                    content += '-';
                  }
                  return content;
                })
              }
            />
            <Table.Column width={'5%'} title="知识点对应课时" dataIndex="lessonName" key="lessonName" />
            <Table.Column
              width={'5%'}
              title="高/低"
              dataIndex="speech.type"
              key="speechType"
              render={type => SpeechTypeText[type]}
            />
            <Table.Column
              width={'25%'}
              title="内容"
              dataIndex="speech.content"
              key="speechContent"
              render={item => item || '-'}
            />
            <Table.Column
              width={'5%'}
              title="操作"
              dataIndex="speech.content"
              key="copy"
              render={speechContent => (
                <CopyToClipboard text={speechContent || ''} onCopy={() => message.success('复制话术成功')}>
                  <Button style={{ padding: 5 }}>复制话术</Button>
                </CopyToClipboard>
              )}
            />
            <Table.Column width={'45%'} />
          </Table>
        );
      }}
    </Query>
  );
};



// WEBPACK FOOTER //
// ./src/screens/group/ExpandedRowRender.tsx